/*
    Main JS for the website
 */

// libraries - dependencies
import 'jquery/src/jquery';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/modal';
import '@fortawesome/fontawesome-free/js/all';
import './app/text-gallery-3d';
import './app/back-to-top';
import './app/contact-form';

import { initDemo1 } from './app/demo1';
import { initHeader } from './app/header';
import { initMinimalMenu } from './app/minimal-menu';
import { initStatistics } from './app/statistics';
import { initCarouselMultiple } from './app/carousel-multi-items/carousel-multi-items';
import { initAccordion } from './app/accordion';

initDemo1();

//initMinimalMenu();
initHeader();
initStatistics();
initCarouselMultiple($('.carousel-multi-item'));
initAccordion();

$().ready(e=>{
    $('.minimal-menu a[href^="#"], .nav-item a[href^="#"]').on('click', function(event) {
        var target = $(this.getAttribute('href'));
        if( target.length ) {
            event.preventDefault();
            $('html, body').stop().animate({
                scrollTop: target.offset().top
            }, 1000);
        }
    });
});
